import { PromiseVoidFunction } from '@dreryk/react-common';

import { FormsTemplates } from '~libs.desktop.shared.user-templates.forms';

import { VisitTemplateFormController } from './form/VisitTemplateForm.types';
import { VisitTemplatesCreateTemplateButton } from './VisitTemplatesCreateTemplateButton';
import { VisitTemplatesUpdateTemplateButton } from './VisitTemplatesUpdateTemplateButton';

type VisitTemplatesSendTemplateButtonProps = {
   handleSubmit: VisitTemplateFormController['handleSubmit'];
   disabled: boolean;
   onSuccess: PromiseVoidFunction;
   shouldConfirmEmptyTemplate: boolean;
};

export const VisitTemplatesSendTemplateButton = FormsTemplates.withTemplateSaveButton<VisitTemplatesSendTemplateButtonProps>(
   VisitTemplatesCreateTemplateButton,
   VisitTemplatesUpdateTemplateButton
);
